import { AnyAttribute, FeatureDetails, LocationList } from '@ljagis/react-mapping';
import {
  Box,
  Button,
  Divider,
  ListItemText,
  ThemeProvider,
  Toolbar,
  createMuiTheme,
} from '@material-ui/core';
import BackIcon from '@material-ui/icons/ArrowBackIosOutlined';
import React, { useState } from 'react';
import { TractorZoneFeature, TractorZoneProperties } from 'services/tractorZones';

interface TractorZonesListProps {
  items: TractorZoneFeature[];
  onItemSelected?: (item: TractorZoneFeature | null) => void;
}

const getAttributes = ({
  zone,
  tractors,
  location,
  cycle1,
  cycle2,
  cycle3,
  cycle4,
  cycle5,
}: TractorZoneProperties) => [
  {
    kind: 'text',
    label: 'Zone',
    value: zone,
  },
  {
    kind: 'text',
    label: 'Tractors',
    value: tractors,
  },
  {
    kind: 'text',
    label: 'Location',
    value: location,
  },
  {
    kind: 'text',
    label: 'First Cycle',
    value: cycle1,
  },
  {
    kind: 'text',
    label: 'Second Cycle',
    value: cycle2,
  },
  {
    kind: 'text',
    label: 'Third Cycle',
    value: cycle3,
  },
  {
    kind: 'text',
    label: 'Fourth Cycle',
    value: cycle4,
  },
  {
    kind: 'text',
    label: 'Fifth Cycle',
    value: cycle5,
  },
];

const renderLocationListItem = (item: TractorZoneFeature) => (
  <ListItemText primary={item.properties.zone} secondary={item.properties.location} />
);

const TractorZoneList: React.FC<TractorZonesListProps> = ({ items, onItemSelected }) => {
  const [single, setSingle] = useState<TractorZoneFeature | null>(null);

  const selectSingle = (item: TractorZoneFeature | null) => {
    setSingle(item);
    onItemSelected && onItemSelected(item);
  };

  if (single) {
    const attributes = getAttributes(single.properties);

    return (
      <Box display="flex" flexDirection="column" overflow="hidden">
        <Box p={2} pb={2} flex="0 0 auto">
          <Toolbar disableGutters style={{ minHeight: 0 }}>
            <Button
              color="primary"
              startIcon={<BackIcon />}
              style={{ marginLeft: -8, marginTop: -6, marginBottom: -6 }}
              onClick={() => selectSingle(null)}
            >
              Back
            </Button>
            <Box flex={1} />
          </Toolbar>
        </Box>
        <Divider />
        <FeatureDetails
          flex={1}
          p={2}
          pt={2}
          title={single.properties.zone}
          attributes={attributes as AnyAttribute[]}
        />
      </Box>
    );
  }

  return (
    <ThemeProvider
      theme={(theme) =>
        createMuiTheme(theme, {
          props: {
            MuiListItem: {
              dense: true,
            },
          },
        })
      }
    >
      <Box py="1">
        <LocationList
          items={items}
          renderItem={renderLocationListItem}
          onLocationClick={selectSingle}
        />
      </Box>
    </ThemeProvider>
  );
};

export default TractorZoneList;
